import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {SvgIconsService} from "../../services/svg.icons.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {LogCat, LogManager} from "../../../../../log";
import {ISvgIcon} from "../../interfaces/svg.icon";
import {AssetProxy} from "../../../../../http/services/assets.proxy";
import {PatientPictureSvgService} from "../../../../../../app.services/patient.summary/components/patient.picture/patient.picture.svg.icons.service";
/**
 * Created by PH-Hanna on 02-Sep-16.
 */

@UntilDestroy()
@Component({
	selector: 'cp-svg-icons-definitions',
	templateUrl: './svg.icons.definitions.template.html',
	styleUrls: ['./svg.icons.definitions.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SvgIconsDefinitionsComponent implements OnInit, OnDestroy {

	public siteSvgIcons: ISvgIcon[] = [];
	public systemIcons: ISvgIcon[] = this.svgIconsService.systemIcons;
	public patientPictureIcons: ISvgIcon[];
	constructor(private svgIconsService: SvgIconsService, 
		private assetProxy:AssetProxy, private cd:ChangeDetectorRef,
		private patientPicture:PatientPictureSvgService,
		) {
		LogManager.debug(LogCat.UI.SvgIconsDefinitions, "constructor()");

		this.svgIconsService.getSvgIcons().pipe(untilDestroyed(this)).subscribe(res => {
			this.svgIconsService.allSvgIcons = res;
			this.patientPictureIcons= this.patientPicture.patientPictureIcons;
			this.svgIconsService.setSvgIcons(res.filter(icon => icon.active && !icon.system));
		});
	}

	ngOnInit() {
		LogManager.debug(LogCat.UI.SvgIconsDefinitions, "ngOnInit()");
		this.assetProxy.getAsStyleFromApi("Icons", "GetFlagWebColoringStyle").pipe(untilDestroyed(this)).subscribe((x) => {
			LogManager.debug(LogCat.UI.SvgIconsDefinitions, "flags style success");
			this.cd.markForCheck();
		}, error => {
			LogManager.error(LogCat.UI.SvgIconsDefinitions, "failed loading flags style -error", error);
		});


		this.svgIconsService.getSvgIconsObservable().pipe(untilDestroyed(this)).subscribe(svgIcons => {
			this.siteSvgIcons = svgIcons;
			this.cd.markForCheck();
		});
	}

	ngOnDestroy() {
		LogManager.debug(LogCat.UI.SvgIconsDefinitions, "ngOnDestroy()");
	}
}
